import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { TypeCache } from '@xanadu/cache';

@Component({
    selector: 'app-type',
    templateUrl: './type.component.html',
    styleUrls: ['./type.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TypeComponent extends InputComponent {
    private readonly typeCache = inject(TypeCache);
    public readonly types = this.typeCache.signal;
}
